// extracted by mini-css-extract-plugin
export default {"dropdown":"IcdDropdown_dropdown__BNIYg","item":"IcdDropdown_item__pSU7X","code":"IcdDropdown_code__NCTLf","details":"IcdDropdown_details__cF0F-","type":"IcdDropdown_type__IYm5T"};